// src/pages/Promotions.js
import React from "react";
import { motion } from "framer-motion";
import Promotions from "../components/Promotions";


const PromotionsPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <Promotions />
    </motion.div>
  );
};

export default PromotionsPage;